<template>
    <b-card no-body>

        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <system-constant-parameter-create-or-update v-model="constant" :errors="errors" :editing="editing"></system-constant-parameter-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    name="system-constant"
                    :add-callback="createNew"
                    search
                    pagination="server"
                    :fields="fields"
                    :buttons="buttons"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import SystemConstantParametersApi from '@/api/system-constant-parameters'
import SystemConstantParameterCreateOrUpdate from './components/SystemConstantParameterCreateOrUpdate'

export default {
    components:{
        BCard,
        SystemConstantParameterCreateOrUpdate
    },
    data(){
        return{
            fields:[
                {name:"Veri Türü",key:"VisibleName",thClass:'w-50'},
                {name:"Değer",key:"Value",thClass:'w-50'},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            errors:{},
            loading:false,
            constant:{
                Id:null,
                CompanySystemConstantDataTypeId:null,
                Value:null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.constant.Id = null
            this.constant.CompanySystemConstantDataTypeId = null
            this.constant.Value = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return SystemConstantParametersApi.Table(data)
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.constant.Id = item.Id
            this.constant.CompanySystemConstantDataTypeId = item.CompanySystemConstantDataTypeId
            this.constant.Value = item.Value
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            SystemConstantParametersApi.CreateOrUpdate(this.editing,this.constant).then(res=>{
                this.$result(res)
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('create-or-update')
                }
                this.loading = false
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.VisibleName} veri türünü silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    SystemConstantParametersApi.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        }
    }
}
</script>

<style>

</style>